/*
 * @Author: jzh
 * @Date: 2020-11-16 11:16:53
 * @LastEditors: jzh
 * @LastEditTime: 2020-11-19 15:50:24
 * @Description: 扩展字段单身份
 */

/* =============================================
   业务功能路由配置文件引入 Start
  *
  *
*/

// 用户维护
import singleUserRoutes from './user/user.routes.js';

// 用户维护
import singleAdminLevelManageRoutes from './adminLevelManage/adminLevelManage.routes.js';

/* 业务功能路由配置文件引入 End */

/* =============================================
   业务功能路由配置写入 Start
  *
  *
*/
const FEATURES_ROUTES = [
  ...singleUserRoutes,
  singleAdminLevelManageRoutes
];

/* 业务功能路由配置写入 End */

const singleRoutes = {
  path: 'single',
  name: 'single',
  component: { template: '<router-view></router-view>' },
  children: [
    ...FEATURES_ROUTES
  ]
};

export default singleRoutes;
